import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";

export default class ActiveSubstanceInput extends React.Component {
  fetchData = search =>
    fetchJson("/mrls/active_substances.json", { search }).then(records =>
      records.map(m => ({ label: m.substance, value: m.active_substance_id }))
    );

  customStyles = () => {
    const { width, defaultStyle } = this.props;
    if (defaultStyle) return {};
    return {
      control: (base, state) => ({
        ...base,
        width: width || 300
      })
    };
  };

  render() {
    const { onChange } = this.props;
    return (
      <AsyncSelect
        placeholder={"Select Active Substance"}
        simpleValue={true}
        autoload={true}
        id="testname_id"
        loadOptions={this.fetchData}
        isClearable
        onChange={onChange}
      />
    );
  }
}
